module.exports = __webpack_public_path__ + "static/efficient-process-8a5f491b9ce8ca0fbc70c140073467aa.png";